module.exports = __webpack_public_path__ + "img/6-1.3b49025f.svg";